import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'antd';
import Loader from '../ui/Loader';

const Loading = ({ className = '', pageHeader }) => {
  return pageHeader ? (
    <div className="container">
      <section className="content-header">
        <Row gutter={{ xs: 14, sm: 14, md: 30, lg: 30, xxl: 30 }} className="content-header">
          <Col sm={24} className="text-center">
            <Loader />
          </Col>
        </Row>
      </section>
    </div>
  ) : (
    <Col sm={24} className={'text-center ' + className}>
      <Loader />
    </Col>
  );
};

Loading.propTypes = {
  pageHeader: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Loading;
